// @ts-nocheck
/* eslint-disable */
export const appReady16Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.84438 9.92608L5.75609 12.6286C6.21048 12.9425 6.83332 12.8286 7.14725 12.3742L13.6238 2.99965" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'ready-16' as const
};